import { render, staticRenderFns } from "./SolicitudesVentaTab.vue?vue&type=template&id=b54204c8&scoped=true"
import script from "./SolicitudesVentaTab.vue?vue&type=script&lang=js"
export * from "./SolicitudesVentaTab.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesVentaTab.vue?vue&type=style&index=0&id=b54204c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54204c8",
  null
  
)

export default component.exports